import { NavIdsEnum } from '@components/header-landing/constants';
import Footer from '@screens/lp-default/components/footer';
import Ecosystem from '@screens/lp-default/components/ecosystem';
import { useGetOffers } from '@screens/hooks/use-get-offers';
import HeroDefault from '@screens/lp-default/components/hero';
import Plans from '@screens/lp-default/components/plans';
import PlansBanner from '@screens/lp-default/components/plans-banner';
import Team from '@screens/lp-default/components/team';
import Timeline from '@screens/lp-default/components/timeline';
import Tools from '@screens/lp-default/components/tools';
import * as Styles from '@screens/lp-default/styles';
import { useEffect } from 'react';

export default function LPDefaultScreen() {
  const { offers, isLoading, loadPlanList } = useGetOffers('LandingPage');

  useEffect(() => {
    loadPlanList();
  }, []);

  return (
    <>
      <Styles.GlobalStyle />
      <Styles.Main>
        <HeroDefault id={NavIdsEnum.HERO} />
        {!isLoading && <PlansBanner offers={offers} />}
        <Tools id={NavIdsEnum.TOOLS} />
        <Team id={NavIdsEnum.TEAM} />
        <Timeline />
        <Plans id={NavIdsEnum.PLANS} offers={offers} isLoading={isLoading} />
        <Ecosystem id={NavIdsEnum.ECOSYSTEM} />
      </Styles.Main>
      <Footer />
    </>
  );
}
